import React, { type ReactNode, useEffect } from 'react';
import { Toaster as ToastContainer } from 'sonner';
import Footer from './Footer';
import Header from './Header';
import 'react-toastify/dist/ReactToastify.css';
import { HiddenLink } from 'shared/src/components/Accessibility';

export default function Container({ children }: { children: ReactNode }) {
  useEffect(() => {
    document.documentElement.classList.add('theme-ev');
    return () => document.documentElement.classList.remove('theme-ev');
  }, []);

  return (
    <div className="theme-ev w-full">
      <HiddenLink href={'#main'}>Skip to main content</HiddenLink>
      <Header />
      <main id="main">
        <div className="px-4 lg:px-16">
          <div className="mx-auto max-w-7xl">{children}</div>
        </div>
      </main>
      <Footer />
      <ToastContainer position="top-center" />
    </div>
  );
}
